<template>
 <dd-form-page
     :submit-route="isSinglePolicy ? 'web_api.v1.policy.storeSingle' : 'web_api.v1.policy.store'"
     :valid-on-init="false"
     @submit="onSubmit"
     :header="pageHeader"
 >
   <template #steps>
     <dd-step title="Polis Type">
       <PolicyType></PolicyType>
     </dd-step>
     <dd-step title="Basis Gegevens">
       <CreateOrEditDetails></CreateOrEditDetails>
     </dd-step>
     <dd-step title="Dekking gegevens">
       <Coverages v-if="form.view_group_id && viewOptions"></Coverages>
       <dd-loading-indicator v-if="loadingViews" message="Dekkingen worden opgehaald..."></dd-loading-indicator>
     </dd-step>
     <dd-step title="Premies">
       <Premiums></Premiums>
     </dd-step>
   </template>
 </dd-form-page>
</template>

<script>
import {mapActions, mapMutations, mapGetters, mapState} from "vuex";
import genericStore from '../store';
import CreateOrEditDetails from '../components/CreateOrEditDetails.vue';
import Coverages from '../components/Coverages.vue';
import PolicyType from '../components/PolicyType.vue';
import Premiums from '../components/Premiums.vue';
import AttachableCategoryTemplateTypeEnum from "../../../enums/AttachableCategoryTemplateTypeEnum";
import customerApi from "~/api/customer";

export default {
  name: "PolicyCreatePage",
  components: {
    PolicyType,
    Premiums,
    CreateOrEditDetails,
    Coverages,
  },
  props: {
    steps: [],
  },
  beforeCreate() {
    if (!('$_generic_insurance' in this.$store._modules.root._children)) {
      this.$store.registerModule('$_generic_insurance', genericStore)
    }
  },
  created() {
    this.setCategory({id: AttachableCategoryTemplateTypeEnum.INSURANCE, name: 'Polissen'});
    this.setPackageId(this.$route.params.package);
    if(!this.isSinglePolicy) {
      this.getPackage();
    }
    this.setCustomerId(this.$route.params.customer);
    this.getInitialCreateOrEditPageData();

    if (this.customerFamily === null) {
      customerApi.findFamily(this.$route.params.customer)
        .then((response) => {
          this.setCustomerFamily(response.data);
        });
    }
  },
  methods: {
    // Root store
    ...mapMutations({
      setCategory: 'SET_CATEGORY',
    }),
    // Specific for insurance.
    ...mapMutations(`$_generic_insurance`, {
      setCustomerId: "SET_CUSTOMER_ID",
      setPackageId: "SET_PACKAGE_ID",
    }),
    ...mapActions(`$_generic_insurance`, {
      getPackage: 'getPackage',
      savePolicy: 'savePolicy',
      getInitialCreateOrEditPageData: "getInitialCreateOrEditPageData",
    }),
    ...mapMutations(`$_generic_insurance`, {
      setFormValue: 'SET_FORM_VALUE',
      setCustomerFamily: "SET_CUSTOMER_FAMILY",
    }),
    onSubmit() {
      this.savePolicy();
    }
  },
  computed: {
    ...mapState(`$_generic_insurance`, {
      form: 'form',
      package : 'package',
      loadingViews: 'loadingViews',
      customerFamily: 'customerFamily',
    }),
    ...mapGetters(`$_generic_insurance`, {
      viewOptions: 'viewOptions',
      isSinglePolicy: 'isSinglePolicy',
    }),
    pageHeader() {
      if (this.isSinglePolicy) {
        return 'Polis aanmaken'
      }
      if(!('name' in this.package)) return '';
      return `Polis aanmaken voor ${this.package?.name}`;
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
</style>
